import component from './BackSkipNext.component';

export default component;
